namespace $ { $mol_style_attach( "piterjs/screen/lines/intro.view.css",
 "[piterjs_screen_lines] {\n\twidth: 25%;\n\tpointer-events: none;\n\tposition: absolute;\n\tz-index: -1;\n}\n"
) }